export function Clone(data) {
  return JSON.parse(JSON.stringify(data));
}
